import React, { useContext, useState } from 'react';
import { Row, Col, Container, Accordion, Badge, useAccordionButton, AccordionContext } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import classNames from 'classnames';

// import seo from '../../../assets/images/Company2.jpeg';
import seo from '../../../assets/images/hero/New folder/Home/Company2.jpeg'
import ContactUS from '../../../assets/images/ContactUS.jpg'



// types
import { Feature, CrmFeatures } from './types';

// images

type FeaturesProps = {
    features: Feature[];
    crmFeatures: CrmFeatures[]
    containerClass?: string;
};

type CustomToggleProps = {
    children: React.ReactNode;
    eventKey: string;
    containerClass: string;
    linkClass: string;
    callback?: (eventKey: string) => void;
};

const CustomToggle = ({ children, eventKey, linkClass, callback }: CustomToggleProps) => {
    const { activeEventKey } = useContext(AccordionContext);


    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
        <Link
            to="#"
            className={classNames(linkClass, {
                collapsed: !isCurrentEventKey,
            })}
            onClick={decoratedOnClick}
        >
            {children}
        </Link>
    );
};



const benefits = [
    {
        icon: "zap",
        title: "Boost Productivity",
        desc: "Reduce manual work with powerful automation.",
    },
    {
        icon: "trending-up",
        title: "Increase Conversions",
        desc: "Get better insights into what drives deals.",
    },
    {
        icon: "users",
        title: "Better Team Collaboration",
        desc: "Share dashboards and goals with your team.",
    },
    {
        icon: "dollar-sign",
        title: "Grow Revenue Faster",
        desc: "Focus on deals that matter with accurate data.",
    },
];


const whyBetterFeatures = [
    {
        title: "Zero learning curve",
        desc: "Get your team up and running in minutes with an intuitive interface designed for real-world sales workflows.",
    },
    {
        title: "Powerful automation & reminders",
        desc: "Never miss a follow-up with intelligent automation that keeps deals moving forward automatically.",
    },
    {
        title: "Clean design — easy adoption",
        desc: "A modern, clutter-free interface your sales team will actually enjoy using every day.",
    },
    {
        title: "Secure, reliable & scalable",
        desc: "Enterprise-grade security and infrastructure that scales effortlessly as your business grows.",
    },
];

const Features1 = ({ features, crmFeatures, containerClass }: FeaturesProps) => {

    const [currentSlide, setCurrentSlide] = useState(0);

    const nextSlide = () =>
        setCurrentSlide((prev) => (prev + 1) % whyBetterFeatures.length);

    const prevSlide = () =>
        setCurrentSlide((prev) => (prev - 1 + whyBetterFeatures.length) % whyBetterFeatures.length);

    return (
        <>
            <section className={containerClass}>
                <Container>
                    <Row className="mt-1">
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                {/* <h2 className="fw-semibold mb-4">All-in-One CRM Stack</h2> */}
                                <h2
                                    style={{
                                        fontSize: "48px",
                                        fontWeight: 700,
                                        background: "linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    All-in-One CRM to Keep Your Sales on Track
                                </h2>
                                <p className="text-muted mb-5">SalesTrackify gives your team everything they need to capture leads, follow up on opportunities and close more deals – all from one central platform.</p>
                            </Col>
                        </Row>

                        {crmFeatures.map((crm, index) => (
                            <Col lg={4} md={6} sm={12} key={index} className="mb-4" data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="p-4 border bg-white rounded-4 h-100 shadow-sm text-start  hover-shadow transition border border-primary p-3 border-2" >
                                    <div className="d-flex align-items-center mb-2">
                                        <div className="me-3 fs-3">{crm.icon}</div>

                                        <h5 className="mb-0 fw-bold text-dark">{crm.title}</h5>
                                    </div>
                                    <ul className="list-unstyled mt-3 mb-0 text-muted small">
                                        {crm.features.map((feat, idx) => (
                                            <li key={idx} className="mb-2 d-flex align-items-start">
                                                <FeatherIcon icon="check-circle" size={14} className="me-2 text-success mt-1" />
                                                {feat}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            <section
                style={{
                    paddingTop: "90px",
                    paddingBottom: "90px",
                }}
            >
                <Container>
                    <Row className="align-items-center">

                        {/* LEFT SIDE */}
                        <Col lg={6} className="mb-4 mb-lg-0">
                            <div className="d-flex align-items-center mb-3">
                                <span
                                    style={{
                                        width: "10px",
                                        height: "10px",
                                        backgroundColor: "#facc15",
                                        display: "inline-block",
                                        marginRight: "10px",
                                    }}
                                />
                                <span className="text-uppercase fw-semibold small text-muted">
                                    Why it’s better
                                </span>
                            </div>

                            <h2
                                className="fw-bold mb-4"
                                style={{ fontSize: "42px", color: "#0f172a" }}
                            >
                                Built for Real Sellers
                            </h2>

                            {whyBetterFeatures.map((item, idx) => (
                                <div key={idx} className="d-flex align-items-center mb-3">
                                    <FeatherIcon
                                        icon="check"
                                        size={20}
                                        className="me-3"
                                        style={{ color: "#22c55e" }}
                                    />
                                    <span className="fs-5 text-dark">{item.title}</span>
                                </div>
                            ))}
                        </Col>

                        {/* RIGHT SIDE CARD */}
                        <Col lg={6}>
                            <div
                                className="rounded-4 shadow-lg p-4 position-relative"
                                style={{
                                    background: "linear-gradient(135deg, #08172E, #0f2a55)",
                                    color: "#ffffff",
                                }}
                            >
                                <div
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "12px",
                                        background: "linear-gradient(135deg, #6366f1, #9333ea)",
                                    }}
                                    className="d-flex align-items-center justify-content-center mb-4"
                                >
                                    <FeatherIcon icon="check" size={28} className="text-white" />
                                </div>

                                <h4 className="fw-bold mb-3 text-white">
                                    {whyBetterFeatures[currentSlide].title}
                                </h4>

                                <p className="fs-5" style={{ color: "#cbd5e1" }}>
                                    {whyBetterFeatures[currentSlide].desc}
                                </p>

                                <hr style={{ borderColor: "rgba(255,255,255,0.2)" }} />

                                <div className="text-warning mb-1">
                                    ★★★★★
                                </div>
                                <small style={{ color: "#cbd5e1" }}>
                                    Loved by sales teams
                                </small>

                                {/* CONTROLS */}
                                <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                                    <button
                                        onClick={prevSlide}
                                        className="btn btn-light rounded-circle"
                                    >
                                        <FeatherIcon icon="chevron-left" />
                                    </button>

                                    {whyBetterFeatures.map((_, i) => (
                                        <span
                                            key={i}
                                            onClick={() => setCurrentSlide(i)}
                                            style={{
                                                width: i === currentSlide ? "24px" : "8px",
                                                height: "8px",
                                                backgroundColor:
                                                    i === currentSlide ? "#ffffff" : "rgba(255,255,255,0.4)",
                                                borderRadius: "10px",
                                                cursor: "pointer",
                                                transition: "all 0.3s",
                                            }}
                                        />
                                    ))}

                                    <button
                                        onClick={nextSlide}
                                        className="btn btn-light rounded-circle"
                                    >
                                        <FeatherIcon icon="chevron-right" />
                                    </button>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>
            {/* Benefits */}
            <section className="py-5"
                style={{ background: "#f0f6ff", }} >
                <Container>
                    {/* SECTION LABEL */}
                    <Row className="mb-4">
                        <Col className="text-center">
                            <span className="fw-semibold text-primary px-3 py-1 rounded-pill"
                                style={{
                                    backgroundColor: "#eef2ff", fontSize: "14px",
                                }} >
                                Benefits
                            </span>

                            <h2
                                className="fw-bold mt-3"
                                style={{
                                    fontSize: "36px",
                                    color: "#0f172a",
                                }}   >
                                Benefits That Drive Real Sales Growth
                            </h2>

                            <p
                                className="text-muted mt-2 mx-auto"
                                style={{ maxWidth: "700px" }}   >
                                Everything you need to boost productivity, improve collaboration,
                                and accelerate revenue growth — all in one CRM platform.
                            </p>
                        </Col>
                    </Row>

                    {/* BENEFITS CARDS */}
                    <Row className="g-4 justify-content-center">
                        {benefits.map((item, index) => (
                            <Col lg={3} md={6} sm={12} key={index}>
                                <div
                                    className="h-100 bg-white rounded-4 p-4 text-start shadow-sm border transition hover-shadow"
                                    data-aos="fade-up"
                                    data-aos-delay={index * 100}
                                >
                                    <div
                                        className="mb-3 d-flex align-items-center justify-content-center rounded-3"
                                        style={{
                                            width: "48px",
                                            height: "48px",
                                            backgroundColor: "#eef2ff",
                                        }}
                                    >
                                        <FeatherIcon
                                            icon={item.icon}
                                            size={22}
                                            className="text-primary"
                                        />
                                    </div>

                                    <h6 className="fw-bold mb-2">{item.title}</h6>
                                    <p className="text-muted mb-0 small">
                                        {item.desc}
                                    </p>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            {/* Your Questions, Answered. */}
            <section style={{ paddingTop: "90px", paddingBottom: "90px" }}>
                <Container>
                    <Row className="align-items-center">

                        {/* LEFT FAQ */}
                        <Col lg={6} className="mb-4 mb-lg-0">
                            <span
                                className="fw-semibold text-primary mb-2 d-inline-block"
                                style={{ fontSize: "14px" }}
                            >
                                FAQs
                            </span>

                            <h2 className="fw-bold mb-4" style={{ fontSize: "42px" }}>
                                Your Questions, Answered.
                            </h2>

                            <Accordion defaultActiveKey="0" flush>
                                {[
                                    {
                                        q: "What is SalesTrackify?",
                                        a: "SalesTrackify is an all-in-one CRM platform designed to help sales teams manage leads, track opportunities, automate follow-ups, and close deals faster."
                                    },
                                    {
                                        q: "How does SalesTrackify help my sales team?",
                                        a: "It centralizes your leads, pipelines, tasks, and reports so your team spends less time on manual work and more time selling."
                                    },
                                    {
                                        q: "Is SalesTrackify easy to use?",
                                        a: "Yes. The platform is built with a clean and intuitive interface that allows teams to get started quickly with minimal training."
                                    },
                                    {
                                        q: "Can I track my sales pipeline in real time?",
                                        a: "Yes, you get real-time visibility into deal stages, conversions, and performance through visual dashboards."
                                    },
                                    {
                                        q: "Does SalesTrackify support automation and reminders?",
                                        a: "Yes. Automated follow-ups, reminders, and alerts ensure you never miss an opportunity."
                                    },
                                    {
                                        q: "Is my data secure with SalesTrackify?",
                                        a: "Absolutely. SalesTrackify follows enterprise-grade security standards to keep your data safe and reliable."
                                    },
                                    {
                                        q: "Can I request a demo before getting started?",
                                        a: "Yes, you can easily book a demo to explore how SalesTrackify fits your sales workflow."
                                    }
                                ].map((item, index) => (
                                    <Accordion.Item eventKey={index.toString()} key={index}>
                                        <Accordion.Header>{item.q}</Accordion.Header>
                                        <Accordion.Body className="text-muted">
                                            {item.a}
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>

                        </Col>

                        {/* RIGHT IMAGE */}
                        <Col lg={6}>
                            <img
                                src={ContactUS}
                                loading="lazy"
                                alt="CoreScripts CEO"
                                className="img-fluid rounded-4 shadow"
                            />
                        </Col>
                    </Row>
                </Container>
            </section>


            <section className="py-5" style={{ backgroundColor: "#f0f6ff" }}>
                <div className="container text-center py-5">
                    <h2
                        className="fw-bold mb-3"
                        style={{
                            fontSize: "35px",
                            background: "linear-gradient(90deg, #2563eb, #3b82f6, #60a5fa)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}
                    >
                        See SalesTrackify in Action
                    </h2>


                    <p className="text-muted fs-5 mx-auto mb-4" style={{ maxWidth: "750px" }}>
                        Experience how SalesTrackify can simplify your sales operations and support your next stage of growth.
                    </p>


                    <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                        <a
                            href="/contact"
                            className="btn btn-primary px-4 py-2 rounded-pill shadow-sm fw-semibold"
                            style={{ fontSize: "16px" }}
                        >
                            Book a Demo
                        </a>
                    </div>
                </div>
            </section>

            {/* Built by */}
            <section className="py-5" style={{
                // background: "linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)",
                paddingTop: "80px",
                paddingBottom: "80px",
            }}>
                <div className="container py-5">
                    <Row className="align-items-center">

                        <Col lg={5} className="mb-4 mb-lg-0">
                            <div
                                style={{
                                    // background: "linear-gradient(135deg, #99c0ff, #8ca3ff, #a884ff)",
                                    borderRadius: "20px",
                                    padding: "20px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={seo}
                                    loading="lazy"
                                    alt="CoreScripts CEO"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        borderRadius: "16px",
                                    }}
                                />
                            </div>
                        </Col>

                        {/* RIGHT SIDE - CONTENT */}
                        <Col lg={7}>
                            <h1
                                className="fw-bold"
                                style={{

                                    fontSize: "42px",
                                    color: "#0f172a",
                                    lineHeight: "1.2",
                                }}
                            >
                                Built by <br />
                                <span style={{ color: "#2563eb" }}> CoreScripts Technologies Ltd</span>
                            </h1>

                            <p className="text-muted fs-5 mt-3" style={{ maxWidth: "650px" }}>
                                SalesTrackify is developed by CoreScripts Technologies Ltd, a UK-based
                                software company delivering bespoke software solutions and full-cycle
                                product engineering services. With a strong focus on reliability,
                                scalability and data security, our team ensures SalesTrackify remains
                                a trusted platform for growing businesses.
                            </p>

                            {/* QUOTE */}
                            <div className="mt-4 p-3 ps-4 border-start"
                                style={{ borderColor: "#3b82f6" }}
                            >
                                <p className="fs-5" style={{ color: "#0f172a" }}>
                                    “Our goal is to build technology that empowers businesses to automate,
                                    scale and grow with confidence — backed by high-quality engineering
                                    and reliable systems.”
                                </p>
                                <h6 className="fw-bold mb-0">CoreScripts Technologies Ltd</h6>
                            </div>


                        </Col>
                    </Row>
                </div>
            </section>

        </>
    );
};


export default Features1;
